import React from "react";
import { useTranslate } from "@refinedev/core";

import { Modal } from "@shared/components";
import { IntegrationForm } from "../IntegrationForm";
import { CreateIntegrationModalProps } from "./types";
import { useCreateIntegrationModal } from "./controller";

export const CreateIntegrationModal = React.memo(
  ({ modalRef, onComplete }: CreateIntegrationModalProps) => {
    const translate = useTranslate();
    const { methods, mutateAsync, isPending } = useCreateIntegrationModal(
      modalRef,
      onComplete
    );

    return (
      <Modal
        ref={modalRef}
        title={translate("v1/integration_admin.titles.create")}
        onConfirm={mutateAsync}
        methods={methods}
        isPending={isPending}
      >
        <IntegrationForm />
      </Modal>
    );
  }
);
